import { render, staticRenderFns } from "./FeatureTag.vue?vue&type=template&id=58a59940"
import script from "./FeatureTag.vue?vue&type=script&lang=js"
export * from "./FeatureTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports